// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","radio":"styles_radio__NHodW","icon":"styles_icon__Q__45","container":"styles_container__hx8CP","inline":"styles_inline__5ILim"};